import { Link } from 'react-router-dom'
// import DropdownMessage from './DropdownMessage'
// import DropdownNotification from './DropdownNotification'
import DropdownUser from './DropdownUser'
// import LogoIcon from '../../images/logo/logo-icon.svg';
import DarkModeSwitcher from './DarkModeSwitcher'
import Logo from '../../../assets/images/weallat-logo.png'
import { Select } from 'components/Form'
import { useDispatch, useSelector } from 'react-redux'
import { setUser } from 'store/auth/userSlice'

const Header = props => {
    const dispatch = useDispatch()
    const userInfo = useSelector(state => state.auth.user)

    return (
        <header className="sticky top-0 flex w-full bg-white z-999 drop-shadow-1 dark:bg-boxdark dark:drop-shadow-none">
            <div className="flex items-center justify-between flex-grow px-2 py-2 shadow-3">
                <div className="flex items-center gap-2 sm:gap-4 lg:hidden">
                    {/* <!-- Hamburger Toggle BTN --> */}
                    <button
                        aria-controls="sidebar"
                        aria-label={props.sidebarOpen ? 'Close sidebar' : 'Open sidebar'}
                        onClick={e => {
                            e.stopPropagation()
                            props.setSidebarOpen(!props.sidebarOpen)
                        }}
                        className="z-99999 block rounded-sm border border-stroke bg-white p-1.5 shadow-sm dark:border-strokedark dark:bg-boxdark lg:hidden"
                    >
                        <span className="relative block h-5.5 w-5.5 cursor-pointer">
                            <span className="absolute right-0 w-full h-full du-block">
                                <span
                                    className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-[0] duration-200 ease-in-out dark:bg-white ${
                                        !props.sidebarOpen && '!w-full delay-300'
                                    }`}
                                ></span>
                                <span
                                    className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-150 duration-200 ease-in-out dark:bg-white ${
                                        !props.sidebarOpen && 'delay-400 !w-full'
                                    }`}
                                ></span>
                                <span
                                    className={`relative left-0 top-0 my-1 block h-0.5 w-0 rounded-sm bg-black delay-200 duration-200 ease-in-out dark:bg-white ${
                                        !props.sidebarOpen && '!w-full delay-500'
                                    }`}
                                ></span>
                            </span>
                            <span className="absolute right-0 w-full h-full rotate-45">
                                <span
                                    className={`absolute left-2.5 top-0 block h-full w-0.5 rounded-sm bg-black delay-300 duration-200 ease-in-out dark:bg-white ${
                                        !props.sidebarOpen && '!h-0 !delay-[0]'
                                    }`}
                                ></span>
                                <span
                                    className={`delay-400 absolute left-0 top-2.5 block h-0.5 w-full rounded-sm bg-black duration-200 ease-in-out dark:bg-white ${
                                        !props.sidebarOpen && '!h-0 !delay-200'
                                    }`}
                                ></span>
                            </span>
                        </span>
                    </button>
                    {/* <!-- Hamburger Toggle BTN --> */}

                    <Link className="flex items-center flex-shrink-0 lg:hidden" to="/">
                        <img src={Logo} alt="Logo" className="w-[40px] h-[40px]" />
                        <h2 className="text-2xl font-bold text-black dark:text-white">Weallat</h2>
                    </Link>
                </div>

                <div className="hidden sm:block"></div>
                <div className="flex items-center gap-3 xsm:gap-4">
                    {userInfo.super_user || userInfo?.branches?.length <= 1 ? null : (
                        <Select
                            options={userInfo?.branches ?? []}
                            size="sm"
                            placeholder="All"
                            name="branch"
                            className="hidden min-w-48 sm:block"
                            value={userInfo?.branch?.length > 1 ? '' : userInfo?.branch ? userInfo?.branch[0] : ''}
                            onChange={e => {
                                const user = {
                                    ...userInfo,
                                    branch: e.target.value ? [e.target.value] : userInfo?.branches.map(item => item.id),
                                }
                                dispatch(setUser(user))
                            }}
                        />
                    )}
                    <ul className="flex items-center gap-2 xsm:gap-4">
                        {/* <!-- Dark Mode Toggler --> */}
                        <DarkModeSwitcher />
                        {/* <!-- Dark Mode Toggler --> */}

                        {/* <!-- Notification Menu Area --> */}
                        {/* <DropdownNotification /> */}
                        {/* <!-- Notification Menu Area --> */}

                        {/* <!-- Chat Notification Area --> */}
                        {/* <DropdownMessage /> */}
                        {/* <!-- Chat Notification Area --> */}
                    </ul>

                    {/* <!-- User Area --> */}
                    <DropdownUser />
                    {/* <!-- User Area --> */}
                </div>
            </div>
        </header>
    )
}

export default Header
